import { Component } from '@angular/core';
import { SyncService } from '../../sync.service';
import { HttpService } from '../../http.service';

@Component({
  selector: 'delete-deal-modal',
  templateUrl: './delete-deal-modal.component.html',
  styleUrls: ['./delete-deal-modal.component.css']
})
export class DeleteDealModalComponent {

	dealPendingDeletion = '';
	dealDeletionModalOpen = false;

	constructor(
		public httpService: HttpService,
		public syncService: SyncService
	) {}

	ngOnInit() {
		this.syncService.dealPendingDeletion$.subscribe((deal) => {
			this.dealPendingDeletion = deal;
		});

		this.syncService.dealDeletionModalOpen$.subscribe((isOpen) => {
			this.dealDeletionModalOpen = isOpen;
		});
	}

	deleteDeal() {
		const userData = this.syncService.userData.getValue();
		this.httpService.deleteDeal(userData, this.dealPendingDeletion);
		this.syncService.updateDealDeletionModalOpen(false);
	}
}
